import { Directive, HostBinding, Input } from '@angular/core';
import { ThasEventType } from '@thiememeulenhoff/analytics-service-client';
import { AttributeDirective } from './attribute.directive';

@Directive({
  selector: '[thasView]',
})
export class ViewDirective extends AttributeDirective {
  protected readonly type = ThasEventType.View;

  @Input('thasView')
  @HostBinding('attr.data-thas-view')
  public value?: string;
}
